import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchProductDetails = async (
  {
    locale,
    slug,
    shipping_location,
    is_advanced_view = false,
    detailed_prices = false,
  }: {
    locale: string;
    slug: string;
    shipping_location?: string;
    is_advanced_view?: boolean;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
): Promise<TProductDetail> => {
  const queries = [];

  if (shipping_location) {
    queries.push(`shipping_location=${encodeURI(shipping_location)}`);
  }

  if (is_advanced_view) {
    queries.push(`is_advanced_view=true`);
  }

  if (detailed_prices) {
    queries.push(`detailed_prices=true`);
  }

  return await fechFromBPartsApi(
    `/${locale}/shop/products/${encodeURI(slug)}${
      queries.length ? `?${queries.join('&')}` : ''
    }`,
    {
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
      credentials: 'include',
    },
    { enableCustomErrorWrapper: true }
  );
};

export default fetchProductDetails;
